import React, { FC, ReactNode } from 'react';
import {
    ToastContainer as ToastContainerBase,
    ToastContainerProps as ToastContainerPropsBase,
} from 'react-toastify';

import { IClassNameProps } from '@bem-react/core';
import { Platform } from "@yandex-int/hr-components/lib";
import { CloseButton as CloseButtonBase } from "@yandex-int/hr-components/CloseButton/CloseButton";
import { Button } from "@yandex-int/hr-components/Button/bundle";
import { CloseButtonProps } from "react-toastify/dist/components";
import { cnToastify } from './Toastify.cn';
import './Toastify.css';
import 'react-toastify/dist/ReactToastify.css';

export type ToastContainerProps = Omit<
    ToastContainerPropsBase,
    'icon' | 'theme' | 'className'
> & {
    className?: string;
    platform?: Platform;
};

export interface IToastContentProps extends IClassNameProps {
    description: string;
    icon?: ReactNode,
    buttonLabel?: string;
    action?: () => void;
}

export const CloseButton = (props: CloseButtonProps) => {
    return <CloseButtonBase className={cnToastify('Close')} size="m" onClick={props.closeToast}/>
};
export const ToastContainer: FC<ToastContainerProps> = (props) => {
    const {
        className,
        closeButton = true,
        platform = Platform.DESKTOP,
        ...other
    } = props;

    return (
        <ToastContainerBase
            className={cnToastify({ view: 'legal' }, [className])}
            closeButton={closeButton ? CloseButton : false}
            hideProgressBar
            icon={false}
            autoClose={5000}
            theme="colored"
            position={
                platform === Platform.DESKTOP ? 'bottom-right' : 'bottom-center'
            }
            {...other}
        />
    );
};

export const ToastContent: FC<IToastContentProps> = (props) => {
    const { description, icon, action, buttonLabel, className } = props;

    return (
        <div className={cnToastify('Content', [className])}>
            {icon && (
                <div className={cnToastify('Icon')}>
                    { icon }
                </div>
            )}
            <div className={cnToastify('Description')}>{description}</div>
            {action && (
                <Button size="m" view="ghost" onClick={action}>
                    {buttonLabel}
                </Button>
            )}
        </div>
    );
};
